import react from 'react';
import styled from "styled-components";
import React from 'react';
import HeroImg from "../Blogssample/heroimgblog/vertical.jpg";
import * as ROUTES from "../../Constants/routes";
import { Link } from 'react-router-dom';

const Main = styled.div`
  max-width: 320px;
  margin: 0 auto;
  @media ${(props) => props.theme.MediaQueries.m.query} {
    max-width: 720px;
  }
  @media ${(props) => props.theme.MediaQueries.l.query} {
    max-width: 1200px;
  }
`;

const Header = styled.h1`
  font-family: ${(props) => props.theme.Fonts.Josefin};
  font-weight: 600;
  color: ${(props) => props.theme.Colors.Header};
  margin-bottom: 20px;
  @media ${(props) => props.theme.MediaQueries.m.query} {
    font-size: 70px;
  }
  @media ${(props) => props.theme.MediaQueries.l.query} {
    font-size: 50px;
  }
`;

const HeroDiv = styled.div`
  max-width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  height: 50vh;
  justify-content:center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  text-align: center;
`;

const Blogging = styled.div`
font-size: 18px;
padding:15px;
text-align:justify;
border-radius:25px;
font-family: ${(props) => props.theme.Fonts.Josefin};
background-color: rgba(255, 255, 255, 0.7);
@media ${(props) => props.theme.MediaQueries.m.query} {
    margin:45px;
    font-size: 25px;
    padding:40px;
  }
  @media ${(props) => props.theme.MediaQueries.l.query} {
  margin:70px;
  font-size: 25px;
  padding:60px;
  }
`;
const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const BackButton = styled(Link)`
  text-decoration: none;
`;

const BackButtonStyled = styled.button`
  background-color: #fff;
  color: #333; 
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ddd; 
  }
`;
const BLOG_NINE = () => {
    return (
        <>
          <HeroDiv
           style={{
             backgroundImage: ` linear-gradient(rgba(0, 0, 0, 0.7),rgba(0, 0, 0, 0.7)) , url(${HeroImg})`,
           }}
          >
            <Header>The Rise of Vertical Forests: A Green Solution for Urban Environments</Header>
          </HeroDiv>
            <Main>
            <Blogging>
              <p>
              Introduction:<br/><br/>
As we witness the rapid urbanization and the ever-increasing population in cities, the need for sustainable and eco-friendly solutions becomes more pressing than ever. One innovative concept that has gained significant attention in recent years is the idea of vertical forests. These towering structures are not only visually stunning but also offer a multitude of environmental benefits. In this blog post, we will explore the concept of vertical forests and how they can revolutionize our urban landscapes.<br/><br/>



What are Vertical Forests? Vertical forests, also known as green skyscrapers or forest towers, are architectural structures that integrate trees, plants, and greenery within their design. These buildings are specifically constructed to accommodate a large number of trees and plants on their balconies, terraces, and facades. The aim is to create a self-sustaining ecosystem that improves air quality, reduces pollution, and enhances the overall well-being of urban dwellers.<br/><br/>


Environmental Benefits: a) Air Purification: Vertical forests act as natural air purifiers by absorbing carbon dioxide and releasing oxygen. According to studies, a single vertical forest can absorb thousands of pounds of carbon dioxide annually, making a significant impact on reducing greenhouse gas emissions. b) Biodiversity Conservation: By creating green spaces in urban areas, vertical forests provide habitats for various bird species, insects, and other wildlife. This helps to preserve biodiversity and restore ecological balance in concrete jungles. c) Noise Reduction: The dense foliage of vertical forests acts as a buffer against noise pollution, shielding residents from the hustle and bustle of city life. d) Temperature Regulation: The presence of trees and plants helps to regulate temperature by providing shade, reducing the heat island effect, and lowering energy consumption for cooling.<br/><br/>


Examples of Vertical Forests: a) Bosco Verticale, Milan: Designed by architect Stefano Boeri, Bosco Verticale is one of the most iconic vertical forest projects in the world. It consists of two residential towers covered in over 20,000 trees and plants, which contribute to the absorption of 30 tons of CO2 annually. b) Nanjing Vertical Forest, China: This project aims to create a vertical forest in the heart of Nanjing, with over 1,100 trees and 2,500 cascading plants. Once completed, it is expected to produce 132 pounds of oxygen daily and absorb 25 tons of CO2 per year. c) 1/JBR Tower, Dubai: This upcoming project in Dubai will feature a 27-story tower covered in lush greenery. It is designed to provide a natural oasis in a bustling city and promote sustainable living.<br/><br/>


Challenges and Future Prospects: While vertical forests offer immense potential for environmental sustainability, several challenges need to be addressed. These include adequate water supply, maintenance of green spaces, and ensuring structural stability. However, as technology advances and architects continue to innovate, these challenges can be overcome. The future prospects of vertical forests look promising, with more cities embracing this concept to create greener, healthier, and more livable urban environments.<br/><br/>



Conclusion:<br/><br/>
Vertical forests represent a paradigm shift in urban architecture, offering a sustainable and visually captivating solution to combat environmental degradation. By integrating nature into our cities, we can create a harmonious coexistence between humans and the environment. As we move forward, it is crucial to prioritize and invest in such eco-friendly initiatives to ensure a greener and more sustainable future for generations to come.
              </p>
             </Blogging>
             <BackButtonWrapper>
              <BackButton to={ROUTES.BLOGS}>
                <BackButtonStyled>Back</BackButtonStyled>
              </BackButton>
            </BackButtonWrapper>
            </Main>
        </>
    );
};
 
export default BLOG_NINE;
